import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export const googleProvider = new GoogleAuthProvider();
// Without this, Firebase silently reuses the browser's single logged-in
// Google session instead of showing the account chooser — force it every time.
googleProvider.setCustomParameters({ prompt: "select_account" });

export const facebookProvider = new FacebookAuthProvider();
// Same idea for Facebook — prompts re-auth instead of silently reusing
// whatever Facebook session is cached in the browser.
facebookProvider.setCustomParameters({ auth_type: "reauthenticate" });

export const appleProvider = new OAuthProvider("apple.com");
// Apple requires these scopes to get name + email on first sign-in
appleProvider.addScope("email");
appleProvider.addScope("name");